//followup issue fixes Aug 18 2:48
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./slice/authSlice";
import { fetchOpenTicketsCount } from "./slice/ticketSlice";
import Psychology from '@mui/icons-material/Psychology';
import './assets/Sidebar.css';
import {
  FaUserAlt,
  FaTachometerAlt,
  FaUser,
  FaPhone,
  FaUserCircle,
  FaBox,
  FaTasks,
  FaCalendarAlt,
  FaSignOutAlt,
  FaQuestionCircle,
  FaBuilding,
  FaUserFriends,
  FaUsers,
  FaUserTie,
  FaClock,
  FaCalendarCheck,
  FaMoneyBillWave,
  FaChartLine,
  FaChartBar,
  FaFileInvoice,
  FaUniversity,
  FaHandHoldingUsd,
  FaRobot,
  FaEnvelope,
  FaPlayCircle,
  FaMapMarkedAlt,
} from "react-icons/fa";
import {
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Avatar,
  Box,
} from "@mui/material";
import {
  StorageRounded,
  RequestQuoteRounded,
  ExpandLess,
  ExpandMore,
  QrCode2Rounded,
  Campaign as CampaignIcon,
  Email as EmailIcon,
  People as PeopleIcon,
  Dashboard as DashboardIcon,
  VerifiedUser as VerifiedUserIcon,
  History as HistoryIcon,
  Assessment as AssessmentIcon,
  Settings as SettingsIcon,
  FactCheck as FactCheckIcon,
  WhatsApp as WhatsAppIcon,
  Chat as ChatIcon,
  Description as DescriptionIcon,
  Contacts as ContactsIcon,
} from "@mui/icons-material";
import { disconnectSocket } from "./socket/socket.js";
import { axiosClientSignIn } from "./axios/api";
import SidebarCountBadge from "./components/SidebarCountBadge";
import estimationsIcon from './assets/Estimations.png';
import WhatsAppUnreadBadge from './WhatsApp-Marketing/shared/WhatsAppUnreadBadge.jsx';

/**
 * Both email modules are lazy route chunks, so the first click used to sit on a spinner while the
 * chunk downloaded -- unlike the rest of the dashboard, which is bundled eagerly. Expanding or even
 * hovering the menu is a strong enough signal of intent to start fetching the landing page's chunk
 * in the background, so the navigation itself feels immediate. Same specifiers as the React.lazy
 * calls in App.jsx, so this warms exactly those chunks rather than creating new ones.
 */
const prefetchEmailMarketing = () => {
  import('./Email-Marketing/pages/Dashboard');
  import('./Email-Marketing/campaigns/CampaignsPage');
};

const prefetchEmailHealth = () => {
  import('./Email-Marketing/verification/pages/VerifyPage.jsx');
};

const availablePages = [
  "dashboard", "leads", "contact", "account", "orders", "meeting",
  "aboutme", "help", "Client Database", "Material Code Database",
  "VendorDatabase", "Estimations", "Quotations", "FollowUp",
  "ColdCalling", "task", "ClientDatabase", "messenger", "HR_MANAGEMENT", "VendorCompetitor", "AI Promoted",
  "Logistics Database",
  "AI Promot", "AI Promote", "AI_Promote", "SOL-Office-Database"
];

function Sidebar({ open }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector((state) => state.auth.user);
  const userId = user ? user.id : null;
  const userRole = user ? user.role : null;

  // Get counts from Redux state
  const assignedTicketsCount = useSelector((state) => state.tickets.assignedTicketsCount);
  const chatInfo = useSelector((state) => state.ui.chatInfo);
  const groupchatInfo = useSelector((state) => state.ui.groupchatInfo);

  // Calculate total unread messages count
  const totalUnreadMessages = Object.values(chatInfo.unreadCounts || {}).reduce((sum, count) => sum + count, 0) +
    Object.values(groupchatInfo.unreadCounts || {}).reduce((sum, count) => sum + count, 0);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [userPages, setUserPages] = useState([]);
  const [openClient, setOpenClient] = useState(false);
  const [openVendor, setOpenVendor] = useState(false);
  const [openColdCalling, setOpenColdCalling] = useState(false);
  const [openAIPromoted, setOpenAIPromoted] = useState(false);
  const [openFollowUp, setOpenFollowUp] = useState(false);
  const [openQuotationFollowUp, setOpenQuotationFollowUp] = useState(false);
  const [openHr, setOpenHr] = useState(false);
  const [openEmailMarketing, setOpenEmailMarketing] = useState(false);
  const [openEmailVerification, setOpenEmailVerification] = useState(false);
  const [openWhatsApp, setOpenWhatsApp] = useState(false);
  const [openLogistics, setOpenLogistics] = useState(false);
  const [openAboutUs, setOpenAboutUs] = useState(false);
  const isSuperAdmin = userRole === "SUPER_ADMIN";

  console.log(userPages, 'userPagesuserPagesuserPagesuserPagesuserPagesuserPagesuserPagesuserPagesuserPagesuserPages')
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const handleClientClick = () => setOpenClient(!openClient);
  const handleVendorClick = () => setOpenVendor(!openVendor);
  const handleColdCallingClick = () => setOpenColdCalling(!openColdCalling);
  const handleAIPromotedClick = () => setOpenAIPromoted(!openAIPromoted);
  const handleFollowUpClick = () => setOpenFollowUp(!openFollowUp);
  const handleHrClick = () => setOpenHr(!openHr);
  const handleEmailMarketingClick = () => {
    if (!openEmailMarketing) prefetchEmailMarketing();
    setOpenEmailMarketing(!openEmailMarketing);
  };
  const handleEmailVerificationClick = () => {
    if (!openEmailVerification) prefetchEmailHealth();
    setOpenEmailVerification(!openEmailVerification);
  };
  const handleWhatsAppClick = () => setOpenWhatsApp(!openWhatsApp);
  const handleLogisticsClick = () => setOpenLogistics(!openLogistics);
  const handleAboutUsClick = () => setOpenAboutUs(!openAboutUs);

  const isActive = (path) => location.pathname === path;
  const hasAIPromoteAccess = userPages.some((page) => {
    const normalized = String(page || "").toLowerCase().replace(/[\s_]/g, "");
    return normalized === "aipromote" || normalized === "aipromoted" || normalized === "aipromot";
  });

  const handleLogout = () => {
    dispatch(logout())
      .unwrap()
      .then(() => {
        setTimeout(() => navigate('/signin'), 100);
        disconnectSocket();
      })
      .catch((err) => console.error("Logout error:", err));
  };

  useEffect(() => {
    if (userId) {
      // Fetch user pages - KEEP ORIGINAL PAGE NAMES WITHOUT NORMALIZATION
      axiosClientSignIn
        .get(`/listroute/getpages/${userId}`)
        .then((response) => {
          setUserPages(response.data.pages.map(page => page.name));
        })
        .catch((error) => console.error("Error fetching user pages:", error));

      // Fetch help ticket counts
      dispatch(fetchOpenTicketsCount());
    }
  }, [userId, dispatch]);

  // Auto-expand dropdowns if active route is inside them
  useEffect(() => {
    if (location.pathname.startsWith("/hr")) setOpenHr(true);
    if (location.pathname.startsWith("/CurrentCustomer") || location.pathname.startsWith("/TargetCustomer")) setOpenClient(true);
    if (location.pathname.startsWith("/email-marketing")) setOpenEmailMarketing(true);
    if (location.pathname.startsWith("/whatsapp-marketing")) setOpenWhatsApp(true);
    if (location.pathname.startsWith("/logistics")) setOpenLogistics(true);
  }, [location.pathname]);

  return (
    <div className={`sidebar ${open ? "open" : "closed"}`}>
      <div className="content">
        <List>

          {/* Dashboard */}
          {userPages.includes("dashboard") && (
            <>
              <ListItemButton component={Link} to="/dashbord" className={isActive("/") ? "active-link" : ""}>
                <FaTachometerAlt />
                <ListItemText primary="Dashboard" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Statistics */}
          {isSuperAdmin && (
            <>
              <ListItemButton component={Link} to="/statistics" className={isActive("/statistics") ? "active-link" : ""}>
                <FaChartBar />
                <ListItemText primary="Statistics" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Client Database */}
          {userPages.includes("Client Database") && (
            <>
              <ListItemButton onClick={handleClientClick}>
                <StorageRounded />
                <ListItemText primary="Client Database" sx={{ marginLeft: 1 }} />
                {openClient ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openClient} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton component={Link} to="/CurrentCustomer" className={isActive("/CurrentCustomer") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <ListItemText primary="Current Customer" />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/TargetCustomer" className={isActive("/TargetCustomer") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <ListItemText primary="Target Customer" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/NotInterested"
                    className={isActive("/NotInterested") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Not Interested" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/Compitator"
                    className={isActive("/Compitator") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Competitor" />
                  </ListItemButton>
                </List>
              </Collapse>
              <hr />
            </>
          )}



          {/* Vendor Database */}
          {userPages.includes("Vendor Database") && (
            <>
              <ListItemButton onClick={handleVendorClick}>
                <StorageRounded />
                <ListItemText primary="Vendor Database" sx={{ marginLeft: 1 }} />
                {openVendor ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openVendor} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton component={Link} to="/VendorDatabase" className={isActive("/VendorDatabase") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <ListItemText primary="Active Vendors" />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/DeletedVendor" className={isActive("/DeletedVendor") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <ListItemText primary="Deleted Vendors" />
                  </ListItemButton>
                </List>
              </Collapse>
              <hr />
            </>
          )}
          {userPages.includes("Logistics Database") && (
            <>
              <ListItemButton onClick={handleLogisticsClick}>
                <StorageRounded />
                <ListItemText primary="Logistics Database" sx={{ marginLeft: 1 }} />
                {openLogistics ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openLogistics} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton component={Link} to="/vendors/air" className={isActive("/vendors/air") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <ListItemText primary="Air" />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/vendors/sea" className={isActive("/vendors/sea") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <ListItemText primary="Sea" />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/vendors/road" className={isActive("/vendors/road") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <ListItemText primary="Road" />
                  </ListItemButton>
                </List>
              </Collapse>
              <hr />
            </>
          )}
          {/* Vendor Competitor */}
          {userPages.includes("Vendor Competitor") && (
            <>
              <ListItemButton
                component={Link}
                to="/VendorCompetitor"
                className={isActive("/VendorCompetitor") ? "active-link" : ""}
              >
                <StorageRounded />
                <ListItemText primary="Vendor Competitor" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}



          {/* Material Code Database */}
          {userPages.includes("Material Code Database") && (
            <>
              <ListItemButton component={Link} to="/MaterialCode" className={isActive("/MaterialCode") ? "active-link" : ""}>
                <QrCode2Rounded />
                <ListItemText primary="Material Code Database" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Leads */}
          {userPages.includes("leads") && (
            <>
              <ListItemButton component={Link} to="/leads" className={isActive("/leads") ? "active-link" : ""}>
                <FaUser />
                <ListItemText primary="Leads" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Estimations */}
          {userPages.includes("Estimations") && (
            <>
              <ListItemButton component={Link} to="/Estimations" className={isActive("/Estimations") ? "active-link" : ""}>
                <Avatar src={estimationsIcon} sx={{ width: 24, height: 24 }} />
                <ListItemText primary="Estimations" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Quotations */}
          {userPages.includes("Quotations") && (
            <>
              <ListItemButton component={Link} to="/QuotationHeader" className={isActive("/QuotationHeader") ? "active-link" : ""}>
                <RequestQuoteRounded />
                <ListItemText primary="Quotation" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Follow Ups */}
          {(userPages.includes("Follow Up") || userPages.includes("FollowUp")) && (
            <>
              <ListItemButton onClick={handleFollowUpClick}>
                <FaPhone />
                <ListItemText primary="Follow Up" sx={{ marginLeft: 1 }} />
                {openFollowUp ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openFollowUp} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* Quotation Follow Ups parent */}
                  <ListItemButton sx={{ pl: 4 }} onClick={() => setOpenQuotationFollowUp(!openQuotationFollowUp)}>
                    <ListItemText primary="Quotation Follow Ups" />
                    {openQuotationFollowUp ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openQuotationFollowUp} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/FollowUpBuying"
                        className={isActive("/FollowUpBuying") ? "active-link" : ""}
                        sx={{ pl: 7 }}
                      >
                        <ListItemText primary="Buying" />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/FollowUpBiddingBudgetary"
                        className={isActive("/FollowUpBiddingBudgetary") ? "active-link" : ""}
                        sx={{ pl: 7 }}
                      >
                        <ListItemText primary="Bidding/Budgetary" />
                      </ListItemButton>
                    </List>
                  </Collapse>

                  {/* Order Follow Ups - direct link, no children */}
                  <ListItemButton
                    component={Link}
                    to="/FollowUpOrder"
                    className={isActive("/FollowUpOrder") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Order Follow Ups" />
                  </ListItemButton>
                </List>
              </Collapse>
              <hr />
            </>
          )}

          {/* Trip Planner — country-wise client visit planning. Shown to
              everyone (not gated on userPages) since it's a brand-new page
              no one's permission list has been updated to include yet. */}
          <ListItemButton
            component={Link}
            to="/TripPlanner"
            className={isActive("/TripPlanner") ? "active-link" : ""}
          >
            <FaMapMarkedAlt />
            <ListItemText primary="Trip Planner" sx={{ marginLeft: 1 }} />
          </ListItemButton>
          <hr />

          {/* Cold Calling - USING ORIGINAL PAGE NAMES */}
          {(userPages.includes("Cold Calling") || userPages.includes("ColdCalling")) && (
            <>
              <ListItemButton onClick={handleColdCallingClick}>
                <FaPhone />
                <ListItemText primary="Cold Calling" sx={{ marginLeft: 1 }} />
                {openColdCalling ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openColdCalling} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    component={Link}
                    to="/ColdCalling"
                    className={isActive("/ColdCalling") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Lost Lead Cold Calling" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/CurrentCustomerColdCalling"
                    className={isActive("/CurrentCustomerColdCalling") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Current Customer Cold Calling" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/TargetCustomerColdCalling"
                    className={isActive("/TargetCustomerColdCalling") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Target Customer Cold Calling" />
                  </ListItemButton>
                </List>
              </Collapse>
              <hr />
            </>
          )}

          {/* AI Promote - USING ORIGINAL PAGE NAMES */}
          {(hasAIPromoteAccess || userPages.includes("Cold Calling") || userPages.includes("ColdCalling")) && (
            <>
              <ListItemButton onClick={handleAIPromotedClick}>
                <FaRobot />
                <ListItemText primary="AI Promote" sx={{ marginLeft: 1 }} />
                {openAIPromoted ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openAIPromoted} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    component={Link}
                    to="/AI_test"
                    className={isActive("/AI_test") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="AI_test" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/Promote"
                    className={isActive("/Promote") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Promote" />
                  </ListItemButton>
                  {/* <ListItemButton
                    component={Link}
                    to="/"
                    className={isActive("/") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="" />
                  </ListItemButton> */}
                </List>
              </Collapse>
              <hr />
            </>
          )}

          {/* Task */}
          {userPages.includes("task") && (
            <>
              <ListItemButton component={Link} to="/maintask" className={isActive("/maintask") ? "active-link" : ""}>
                <FaTasks />
                <ListItemText primary="Task" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Messenger */}
          {userPages.includes("messenger") && (
            <>
              <ListItemButton component={Link} to="/chatapp" className={isActive("/chatapp") ? "active-link" : ""}>
                <FaTasks />
                <ListItemText primary="Messenger" sx={{ marginLeft: 1 }} />
                <Box sx={{ marginLeft: '8px' }}>
                  <SidebarCountBadge count={totalUnreadMessages} color="#d32f2f" size="medium" />
                </Box>
              </ListItemButton>
              <hr />
            </>
          )}


          {/* Contact */}
          {/* {userPages.includes("contact") && (
            <>
              <ListItemButton component={Link} to="/contact" className={isActive("/contact") ? "active-link" : ""}>
                <FaPhone />
                <ListItemText primary="Contact" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Account */}
          {/* {userPages.includes("account") && (
            <>
              <ListItemButton component={Link} to="/account" className={isActive("/account") ? "active-link" : ""}>
                <FaUserCircle />
                <ListItemText primary="Account" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )} */}

          {/* Orders */}
          {userPages.includes("orders") && (
            <>
              <ListItemButton component={Link} to="/orders" className={isActive("/orders") ? "active-link" : ""}>
                <FaBox />
                <ListItemText primary="Orders" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Meeting */}
          {userPages.includes("meeting") && (
            <>
              <ListItemButton component={Link} to="/meeting" className={isActive("/meeting") ? "active-link" : ""}>
                <FaCalendarAlt />
                <ListItemText primary="Meeting" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Todo */}
          {userPages.includes("todo") && (
            <>
              <ListItemButton component={Link} to="/todo" className={isActive("/todo") ? "active-link" : ""}>
                <FaQuestionCircle />
                <ListItemText primary="Todo" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Client Registration */}
          {userPages.includes("client-registration") && (
            <>
              <ListItemButton component={Link} to="/client-registration" className={isActive("/client-registration") ? "active-link" : ""}>
                <FaUserFriends />
                <ListItemText primary="Client Registration" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Help */}
          {userPages.includes("help") && (
            <>
              <ListItemButton component={Link} to="/help" className={isActive("/help") ? "active-link" : ""}>
                <FaQuestionCircle />
                <ListItemText primary="Help" sx={{ marginLeft: 1 }} />
                <Box sx={{ marginLeft: '8px' }}>
                  <SidebarCountBadge count={assignedTicketsCount} color="#d32f2f" size="medium" />
                </Box>
              </ListItemButton>
              <hr />
            </>
          )}
          {/* HR Management - SPECIAL HANDLING FOR BOTH PAGE NAME FORMATS */}
          {(userPages.includes("HR_MANAGEMENT") || userPages.includes("HR_MANGEMENT")) && (
            <>
              <ListItemButton onClick={handleHrClick}>
                <FaUsers />
                <ListItemText primary="HR Management" sx={{ marginLeft: 1 }} />
                {openHr ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openHr} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* Core HR */}
                  <ListItemButton component={Link} to="/hr/dashboard" className={isActive("/hr/dashboard") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaTachometerAlt />
                    <ListItemText primary="HR Dashboard" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/hr/ai-automation"
                    className={isActive("/hr/ai-automation") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <Psychology sx={{ fontSize: 20 }} />
                    <ListItemText primary="AI Automation" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/employees" className={isActive("/hr/employees") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaUsers />
                    <ListItemText primary="Employee Directory" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/leave" className={isActive("/hr/leave") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaCalendarCheck />
                    <ListItemText primary="Leave Management" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/attendance" className={isActive("/hr/attendance") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaClock />
                    <ListItemText primary="Attendance" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/payroll-dashboard" className={isActive("/hr/payroll-dashboard") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaMoneyBillWave />
                    <ListItemText primary="Payroll Dashboard" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/allowances" className={isActive("/hr/allowances") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaChartLine />
                    <ListItemText primary="Allowances" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/deductions" className={isActive("/hr/deductions") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaChartBar />
                    <ListItemText primary="Deductions" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/payslips" className={isActive("/hr/payslips") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaFileInvoice />
                    <ListItemText primary="Payslips" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/loans" className={isActive("/hr/loans") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaUniversity />
                    <ListItemText primary="Loans & Advances" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/reimbursements" className={isActive("/hr/reimbursements") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaHandHoldingUsd />
                    <ListItemText primary="Reimbursements" sx={{ marginLeft: 1 }} />
                  </ListItemButton>

                  {/* Recruitment Section */}
                  <ListItemText
                    primary="Recruitment"
                    sx={{ pl: 3, pt: 1, color: "#aaa", fontSize: "0.8rem", fontWeight: "bold" }}
                  />
                  <ListItemButton component={Link} to="/hr/recruitment/dashboard" className={isActive("/hr/recruitment/dashboard") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaTachometerAlt />
                    <ListItemText primary="Recruitment Dashboard" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/designations" className={isActive("/hr/designations") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaUserTie />
                    <ListItemText primary="Designations" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/recruitment/candidates" className={isActive("/hr/recruitment/candidates") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaUser />
                    <ListItemText primary="Candidates" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/recruitment/job-postings" className={isActive("/hr/recruitment/job-postings") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaQuestionCircle />
                    <ListItemText primary="Job Postings" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/recruitment/interviews" className={isActive("/hr/recruitment/interviews") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaCalendarAlt />
                    <ListItemText primary="Interviews" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/recruitment/call-details" className={isActive("/hr/recruitment/call-details") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaPhone />
                    <ListItemText primary="Call Details" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/hr/recruitment/call-report" className={isActive("/hr/recruitment/call-report") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaPhone />
                    <ListItemText primary="Call Report" sx={{ marginLeft: 1 }} />
                  </ListItemButton>
                </List>
              </Collapse>
              <hr />
            </>
          )}

          {/* About Me */}
          {userPages.includes("aboutme") && (
            <>
              <ListItemButton component={Link} to="/aboutme" className={isActive("/aboutme") ? "active-link" : ""}>
                <FaUserAlt />
                <ListItemText primary="Profile" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}
          {userPages.includes("About-us") && (
            <>
              <ListItemButton onClick={handleAboutUsClick}>
                <FaUserAlt />
                <ListItemText primary="About-us" sx={{ marginLeft: 1 }} />
                {openAboutUs ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openAboutUs} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton component={Link} to="/aboutus" className={isActive("/aboutus") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaBuilding style={{ fontSize: 14, marginRight: 6 }} />
                    <ListItemText primary="Company Info" />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/aboutus/training" className={isActive("/aboutus/training") ? "active-link" : ""} sx={{ pl: 4 }}>
                    <FaPlayCircle style={{ fontSize: 14, marginRight: 6 }} />
                    <ListItemText primary="Training" />
                  </ListItemButton>
                  {userPages.includes("ListUser") && (
                    <ListItemButton component={Link} to="/ListUser" className={isActive("/ListUser") ? "active-link" : ""} sx={{ pl: 4 }}>
                      <FaQuestionCircle style={{ fontSize: 14, marginRight: 6 }} />
                      <ListItemText primary="ListUser" />
                    </ListItemButton>
                  )}
                  {userPages.includes("domain-expiry-page") && (
                    <ListItemButton component={Link} to="/domain-expiry-page" className={isActive("/domain-expiry-page") ? "active-link" : ""} sx={{ pl: 4 }}>
                      <FaCalendarCheck style={{ fontSize: 14, marginRight: 6 }} />
                      <ListItemText primary="DOMAIN-EXPIRY-PAGE" />
                    </ListItemButton>
                  )}
                </List>
              </Collapse>
              <hr />
            </>
          )}

          {userPages.includes("sol-office-database") && (
            <>
              <ListItemButton component={Link} to="/sol-office-database" className={isActive("/sol-office-database") ? "active-link" : ""}>
                <FaUserAlt />
                <ListItemText primary="SOL Office Database" sx={{ marginLeft: 1 }} />
              </ListItemButton>
              <hr />
            </>
          )}

          {/* Sales Command Center */}
          {userPages.includes("sales-command-center") && ( 
          <>
            <ListItemButton
              component={Link}
              to="/sales-command-center"
              className={location.pathname.startsWith("/sales-command-center") ? "active-link" : ""}
            >
              <FaPhone />
              <ListItemText primary="Sales Command Center" sx={{ marginLeft: 1 }} />
            </ListItemButton>
            <hr />
          </>
         )} 

          {/* Email Marketing */}
          {/* TESTING: guard bypassed for local access — restore: userPages.includes("email-marketing") */}
          {userPages.includes("email-marketing") && (
            <>
              <ListItemButton onClick={handleEmailMarketingClick} onMouseEnter={prefetchEmailMarketing}>
                <FaEnvelope />
                <ListItemText primary="Email Marketing" sx={{ marginLeft: 1 }} />
                {openEmailMarketing ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openEmailMarketing} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    component={Link}
                    to="/email-marketing"
                    className={isActive("/email-marketing") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <DashboardIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="Dashboard" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/email-marketing/campaigns"
                    className={isActive("/email-marketing/campaigns") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <CampaignIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="Campaigns" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/email-marketing/templates"
                    className={isActive("/email-marketing/templates") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <EmailIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="Templates" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/email-marketing/subscribers"
                    className={isActive("/email-marketing/subscribers") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <PeopleIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="All Contacts" />
                  </ListItemButton>

                  {/* Email Verification Nested Dropdown */}
                  <ListItemButton onClick={handleEmailVerificationClick} onMouseEnter={prefetchEmailHealth} sx={{ pl: 4 }}>
                    <VerifiedUserIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="Email Health" />
                    {openEmailVerification ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openEmailVerification} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/email-marketing/verification"
                        className={isActive("/email-marketing/verification") ? "active-link" : ""}
                        sx={{ pl: 7 }}
                      >
                        <FactCheckIcon sx={{ fontSize: 18, mr: 1 }} />
                        <ListItemText primary="Check an address" />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/email-marketing/verification/batch"
                        className={isActive("/email-marketing/verification/batch") ? "active-link" : ""}
                        sx={{ pl: 7 }}
                      >
                        <StorageRounded sx={{ fontSize: 18, mr: 1 }} />
                        <ListItemText primary="Clean a list" />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/email-marketing/verification/history"
                        className={isActive("/email-marketing/verification/history") ? "active-link" : ""}
                        sx={{ pl: 7 }}
                      >
                        <HistoryIcon sx={{ fontSize: 18, mr: 1 }} />
                        <ListItemText primary="Results" />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/email-marketing/verification/analytics"
                        className={isActive("/email-marketing/verification/analytics") ? "active-link" : ""}
                        sx={{ pl: 7 }}
                      >
                        <AssessmentIcon sx={{ fontSize: 18, mr: 1 }} />
                        <ListItemText primary="List health" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </List>
              </Collapse>
              <hr />
            </>
          )}

          {/* WhatsApp Marketing */}
          {/* TESTING: guard bypassed for local access — restore: userPages.includes("whatsapp-marketing") */}
          {userPages.includes("whatsapp-marketing") && (
            <>
              <ListItemButton onClick={handleWhatsAppClick}>
                <WhatsAppIcon />
                <ListItemText primary={<WhatsAppUnreadBadge>WhatsApp CRM</WhatsAppUnreadBadge>} sx={{ marginLeft: 1 }} />
                {openWhatsApp ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openWhatsApp} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    component={Link}
                    to="/whatsapp-marketing"
                    className={isActive("/whatsapp-marketing") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <DashboardIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="Dashboard" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/whatsapp-marketing/inbox"
                    className={isActive("/whatsapp-marketing/inbox") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ChatIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="Live Inbox" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/whatsapp-marketing/campaigns"
                    className={isActive("/whatsapp-marketing/campaigns") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <CampaignIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="Campaigns" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/whatsapp-marketing/templates"
                    className={isActive("/whatsapp-marketing/templates") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <DescriptionIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="Templates" />
                  </ListItemButton>
                  <ListItemButton
                    component={Link}
                    to="/whatsapp-marketing/contacts"
                    className={isActive("/whatsapp-marketing/contacts") ? "active-link" : ""}
                    sx={{ pl: 4 }}
                  >
                    <ContactsIcon sx={{ fontSize: 18, mr: 1 }} />
                    <ListItemText primary="All Contacts" />
                  </ListItemButton>
                </List>
              </Collapse>
              <hr />
            </>
          )}

        </List>
      </div>

    </div>
  );
}

export default Sidebar;

